<template>
<div>
  <vue-chart chart-type="GeoChart" :columns="columns" :rows="rows" :options="options"></vue-chart>
</div>
</template>

<script>
export default {
  data() {
    return {
      columns: [{
        type: 'string',
        label: 'Country',
      }, {
        type: 'number',
        label: 'Popularity',
      }],
      rows: [
        ['Germany', 200],
        ['United States', 300],
        ['Brazil', 400],
        ['Canada', 600],
        ['France', 201],
      ],
      options: {
        title: 'Popularity by Countries',
        width: '100%',
        height: '400px',
      },
    };
  },
  methods: {
    redraw() {
      this.$children[0].drawChart();
    },
  },
  mounted() {
    window.addEventListener('resize', this.redraw);
  },
  destroyed() {
    window.removeEventListener('resize', this.redraw);
  },
};
</script>
